const { TextControl, SelectControl, PanelBody, ToggleControl, Button } =
  wp.components;
const { useSelect } = wp.data;
const { registerBlockType } = wp.blocks;
const { InspectorControls } = wp.blockEditor;

const { __ } = wp.i18n;

registerBlockType('pg/team-section', {
  title: 'PG Team Section',
  icon: 'groups',
  category: 'layout',
  attributes: {
    sectionClass: { type: 'string', default: 'section-light-secondary' },
    teamMembers: {
      type: 'array',
      default: [],
    },
    teamMembersJson: { type: 'string', default: '[]' },
  },
  edit: ({ attributes, setAttributes }) => {
    const { sectionClass, teamMembers } = attributes;

    const allPeople = useSelect((select) => {
      return select('core').getEntityRecords('postType', 'people', {
        per_page: -1,
      });
    }, []);

    const peopleOptions = allPeople
      ? allPeople.map((person) => ({
          label: person.acf?.person_name || person.title.rendered,
          value: person.id,
        }))
      : [];

    const addPerson = () => {
      const newTeamMembers = [...teamMembers, { id: 0, isWide: false }];
      setAttributes({
        teamMembers: newTeamMembers,
        teamMembersJson: JSON.stringify(
          newTeamMembers.map((member) => ({
            id: member.id,
            isWide: member.isWide,
          }))
        ),
      });
    };

    const removePerson = (index) => {
      const updatedTeamMembers = teamMembers.filter((_, i) => i !== index);
      setAttributes({
        teamMembers: updatedTeamMembers,
        teamMembersJson: JSON.stringify(
          updatedTeamMembers.map((member) => ({
            id: member.id,
            isWide: member.isWide,
          }))
        ),
      });
    };

    const updatePerson = (index, key, value) => {
      const newTeamMembers = [...teamMembers];
      newTeamMembers[index][key] = value;

      setAttributes({
        teamMembers: newTeamMembers,
        teamMembersJson: JSON.stringify(
          newTeamMembers.map((member) => ({
            id: member.id,
            isWide: member.isWide,
          }))
        ),
      });
    };

    const onChangeSectionClass = (newClass) => {
      setAttributes({ sectionClass: newClass });
    };

    return (
      <section className={sectionClass}>
        <InspectorControls>
          <PanelBody title={__('Section Settings')}>
            <SelectControl
              label={__('Section Class')}
              value={sectionClass}
              options={[
                { label: 'Light Secondary', value: 'section-light-secondary' },
                { label: 'Light Primary', value: 'section-light-primary' },
                { label: 'Dark Secondary', value: 'section-dark-secondary' },
                { label: 'Dark Primary', value: 'section-dark-primary' },
              ]}
              onChange={onChangeSectionClass}
            />
          </PanelBody>
          <Button isPrimary onClick={addPerson}>
            + Add Person
          </Button>
          {teamMembers.map((member, index) => (
            <PanelBody
              title={`Person ${index + 1}`}
              initialOpen={true}
              key={index}
            >
              <SelectControl
                label={__('Select Person')}
                value={member.id}
                options={peopleOptions}
                onChange={(value) => updatePerson(index, 'id', parseInt(value))}
              />
              <ToggleControl
                label={__('Wide Card')}
                checked={!!member.isWide}
                onChange={(value) => updatePerson(index, 'isWide', value)}
              />
              <Button isDestructive onClick={() => removePerson(index)}>
                Remove Person
              </Button>
            </PanelBody>
          ))}
        </InspectorControls>
        <div className="team-wrapper">
          {teamMembers.map((member, index) => {
            const personDetails = allPeople?.find(
              (person) => person.id === member.id
            );
            return (
              <div
                key={index}
                className={`person-card ${member.isWide ? 'person-card-wide' : ''}`}
                data-id={member.id}
                data-wide={member.isWide}
              >
                <div className="person-photo">
                  <img
                    src={
                      personDetails?.featured_image_url ||
                      '/wp-content/themes/positiongreen/resources/images/placeholders/placeholder_7.png'
                    }
                    alt={personDetails?.acf?.person_name || 'Placeholder'}
                  />
                </div>
                <div className="person-info">
                  <h4>{personDetails?.acf?.person_name}</h4>
                  <p className="person-title">
                    {personDetails?.acf?.person_title}
                  </p>
                  {personDetails?.acf?.person_email && (
                    <p className="person-email">
                      <a href={`mailto:${personDetails.acf.person_email}`}>
                        {personDetails.acf.person_email}
                      </a>
                    </p>
                  )}
                  {personDetails?.acf?.person_phone && (
                    <p className="person-phone">
                      {personDetails.acf.person_phone}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    );
  },
  save: ({ attributes }) => {
    const { sectionClass, teamMembersJson } = attributes;

    return (
      <section className={sectionClass}>
        <div className="team-wrapper" data-team-members={teamMembersJson}></div>
      </section>
    );
  },
});
